import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import { ConfigProvider } from "./config/ConfigContext";

import 'antd/dist/reset.css';

import '../src/styles/main.scss';

import App from './layout/App';

import './utils/axios.config';
import rootReducer from './containers/reducers';

const middlewareEnhancer = applyMiddleware(thunkMiddleware);

const store = createStore(rootReducer, undefined, composeWithDevTools(middlewareEnhancer));

const root = ReactDOM.createRoot(document.getElementById('__calculator_root__'));
root.render(
  <Provider store={store}>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </Provider>
);
